import * as ServiceProduct from '../services/products';
import i18n from '../translations'

export default {
    namespaced: true,
    actions: {
        async getProducts ({ commit }) {
            let response = await ServiceProduct.getProducts();
            if (response.data) {
                let products =  response.data.productCollection.allProducts.filter(product => product.price > 0);
                commit('setProducts', products);
                commit('setProductsTotal',products.length)
            } else {
                console.log(response)
            }
        },
        async getProductsToCardCode( context) {

                let shippingAddress = context.rootState.cart.order.shipping.addressName;
                if(typeof shippingAddress != "undefined") {
                    let response = await ServiceProduct.getProductsByCardCode(context.rootState.auth.user.cardCode, shippingAddress);
                    if (response.data) {
                        let products =  response.data.dedicatedCollection.allProducts.filter(product => product.price > 0);
                       // products =  products.sort(function(a, b) {
                       //      return (a.top)? 1: -1;
                       //  });
                        context.commit('setProducts', products);
                        context.commit('setProductsTotal',products.length)
                    } else {
                        console.log(response)
                    }
                }
        }
    },
    state: {
        products: [],
        productsTotal: 0,
        currentPage: 1,
        pageSize: 10,
        searchTerm: ''
    },
    getters: {
        filteredProducts: state => {
            let loweredTerm = state.searchTerm.toLowerCase()
            let regex = new RegExp(loweredTerm.split(' ').join('.*'))
            if (state.searchTerm) {
                return state.products.filter(product =>{
                    let translate = i18n.locale;
                    if(translate === 'pl'){
                        return regex.test(product.name.toLowerCase()) || String(product.sku).toLowerCase().includes(loweredTerm);
                    }else{
                        return regex.test(product.descriptionEn.toLowerCase()) || String(product.sku).toLowerCase().includes(loweredTerm);
                    }
                })
            } else {
                return state.products
            }
        },
        processedProducts: (state, getters) => {
            let index = (state.currentPage - 1) * state.pageSize;
            return getters.filteredProducts.slice(index, index + state.pageSize);
        },
        processedProductsTotal: (state, getters) => {
            return getters.filteredProducts.length;
        },
        pageCount:  (state, getters) => {
            return Math.ceil(getters.processedProductsTotal / state.pageSize)
        },
        itemCount: state =>
            state.order.lines.reduce((total, line) => total + line.quantity, 0),
        totalPrice: state =>
            state.order.lines.reduce(
                (total, line) => total + line.quantity * line.product.price,
                0
            ),
    },
    mutations: {
        setSearchTerm(state, term) {
            state.searchTerm = term;
            state.currentPage = 1;
        },
        setProductsTotal(state, productsNumber) {
            state.productsTotal = productsNumber;
        },
        setProducts(state, products) {
            state.products = products;
        },
        setCurrentPage(state, page) {
            state.currentPage = page;
        },
        setPageSize(state, size) {
            state.pageSize = size;
            state.currentPage = 1;
        },
        changeQuantity(state, update) {
            update.line.quantity = update.quantity;
        },
    },
};
